module.exports = __webpack_public_path__ + "img/crew.c5f8b62a.jpg";